import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, Description, Field, Input } from "@headlessui/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setUser, UserRole } from "../../app/userSlice";
import { useAgreeToTermsMutation } from "./termsOfServiceApiSlice";

export default function TermsOfService() {
	const { config } = useAppSelector((state) => state.site);
	const user = useAppSelector((state) => state.user);
	const [agreed, setAgreed] = useState(false);

	const [callAgreeToTerms] = useAgreeToTermsMutation();

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	function handleSave() {
		if (agreed) {
			callAgreeToTerms()
				.unwrap()
				.then(() => {
					dispatch(setUser({ ...user, bypassTermsOfService: true }));
					navigate(
						user.requiresAccountConfirmation && !user.isImpersonating
							? "/myAccount"
							: user.role === UserRole.Proctor || user.role === UserRole.Writer
								? "/courses"
								: "/adminHome"
					);
				});
		}
	}

	return (
		<section>
			<iframe
				src={config?.termsOfServiceEmbedUrl ?? config?.termsOfServiceUrl ?? ""}
				className="w-full h-[600px]"></iframe>
			<Field className="flex items-center justify-center mt-4 gap-x-4">
				<Input
					id="termsOfServiceCheckbox"
					type="checkbox"
					checked={agreed}
					className="size-4 rounded-sm border-2 border-gray-300 text-primary-600 focus:ring-primary-600"
					onChange={() => setAgreed(!agreed)}
				/>
				<Description>I have read and agree to the Terms of Service.</Description>
			</Field>

			<div className="mt-6 flex items-center justify-center gap-x-6">
				<Button className="btn btn-primary" disabled={!agreed} onClick={() => handleSave()}>
					Accept
				</Button>
				<Button className="btn btn-naked" onClick={() => navigate("/logout")}>
					Cancel
				</Button>
			</div>
		</section>
	);
}
